
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
        <h2 className="text-2xl font-semibold text-gray-700 mb-6">Página no encontrada</h2>
        <p className="text-gray-600 mb-8">
          La página que está buscando no existe o ha sido movida.
        </p>
        <Button onClick={() => navigate("/")} className="px-6 py-3">
          Volver al inicio
        </Button>
      </div>
    </div>
  );
};

export default NotFound;
